export default "__VITE_ASSET__DElMhGp3__"